import React from "react";

export const AuroraHeart = ({ className = "", size = 120, animated = true }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 200"
    className={`aurora-heart ${animated ? "aurora-heart--animated" : ""} ${className}`.trim()}
    aria-hidden="true"
  >
    <defs>
      <radialGradient id="ah-grad" cx="50%" cy="50%" r="60%">
        <stop offset="0%" stopColor="#F3A5C0" stopOpacity="1" />
        <stop offset="45%" stopColor="#F3C35A" stopOpacity="0.9" />
        <stop offset="75%" stopColor="#4ED8E6" stopOpacity="0.85" />
        <stop offset="100%" stopColor="#12052E" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="ah-stroke" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F3C35A" />
        <stop offset="50%" stopColor="#F3A5C0" />
        <stop offset="100%" stopColor="#4ED8E6" />
      </linearGradient>
    </defs>
    <circle className="aurora-heart__glow" cx="100" cy="100" r="90" fill="url(#ah-grad)" opacity="0.55" />
    <path
      className="aurora-heart__path"
      d="M100 165 C 40 130, 20 95, 40 70 C 55 50, 85 50, 100 80 C 115 50, 145 50, 160 70 C 180 95, 160 130, 100 165 Z"
      fill="none"
      stroke="url(#ah-stroke)"
      strokeWidth="2.5"
      strokeLinejoin="round"
      opacity="0.9"
    />
  </svg>
);

export const AuroraWordmark = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <AuroraHeart size={28} />
    <span className="font-serif text-[1.35rem] tracking-tight text-white">
      withAurora<span className="text-[var(--aurora-gold)]">.love</span>
    </span>
  </span>
);
